// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file truck.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ContainerType, ContainerTypeJson } from "./container_group_pb";
import { file_container_group } from "./container_group_pb";
import type { JobType, JobTypeJson, TruckEngineType, TruckEngineTypeJson, TruckLoadType, TruckLoadTypeJson, TruckStandard, TruckStandardJson, TruckStatus, TruckStatusJson, TruckType, TruckTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { ListInfo, ListInfoJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Organization, OrganizationJson } from "./organization_pb";
import { file_organization } from "./organization_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file truck.proto.
 */
export const file_truck: GenFile = /*@__PURE__*/
  fileDesc("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", [file_container_group, file_enums, file_general, file_google_protobuf_timestamp, file_organization]);

/**
 * @generated from message raccoonai.TruckPositionList
 */
export type TruckPositionList = Message<"raccoonai.TruckPositionList"> & {
  /**
   * map of truck_id to TruckPosition
   *
   * @generated from field: map<uint64, raccoonai.TruckPositionList.TruckPosition> truck_positions = 1 [json_name = "truck_positions"];
   */
  truckPositions: { [key: string]: TruckPositionList_TruckPosition };
};

/**
 * @generated from message raccoonai.TruckPositionList
 */
export type TruckPositionListJson = {
  /**
   * map of truck_id to TruckPosition
   *
   * @generated from field: map<uint64, raccoonai.TruckPositionList.TruckPosition> truck_positions = 1 [json_name = "truck_positions"];
   */
  truck_positions?: { [key: string]: TruckPositionList_TruckPositionJson };
};

/**
 * Describes the message raccoonai.TruckPositionList.
 * Use `create(TruckPositionListSchema)` to create a new message.
 */
export const TruckPositionListSchema: GenMessage<TruckPositionList, {jsonType: TruckPositionListJson}> = /*@__PURE__*/
  messageDesc(file_truck, 0);

/**
 * @generated from message raccoonai.TruckPositionList.TruckPosition
 */
export type TruckPositionList_TruckPosition = Message<"raccoonai.TruckPositionList.TruckPosition"> & {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: required double latitude = 2;
   */
  latitude: number;

  /**
   * @generated from field: required double longitude = 3;
   */
  longitude: number;

  /**
   * @generated from field: optional uint32 angle = 4;
   */
  angle: number;

  /**
   * When the tracker reported this point.
   *
   * @generated from field: optional google.protobuf.Timestamp timestamp = 5;
   */
  timestamp?: Timestamp;
};

/**
 * @generated from message raccoonai.TruckPositionList.TruckPosition
 */
export type TruckPositionList_TruckPositionJson = {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: required double latitude = 2;
   */
  latitude?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required double longitude = 3;
   */
  longitude?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint32 angle = 4;
   */
  angle?: number;

  /**
   * When the tracker reported this point.
   *
   * @generated from field: optional google.protobuf.Timestamp timestamp = 5;
   */
  timestamp?: TimestampJson;
};

/**
 * Describes the message raccoonai.TruckPositionList.TruckPosition.
 * Use `create(TruckPositionList_TruckPositionSchema)` to create a new message.
 */
export const TruckPositionList_TruckPositionSchema: GenMessage<TruckPositionList_TruckPosition, {jsonType: TruckPositionList_TruckPositionJson}> = /*@__PURE__*/
  messageDesc(file_truck, 0, 0);

/**
 * @generated from message raccoonai.Truck
 */
export type Truck = Message<"raccoonai.Truck"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * To be deprecated in favor of truck_type.type
   *
   * @generated from field: optional raccoonai.TruckType type = 3;
   */
  type: TruckType;

  /**
   * @generated from field: required string plate_number = 4 [json_name = "plate_number"];
   */
  plateNumber: string;

  /**
   * @generated from field: required raccoonai.TruckStatus status = 5;
   */
  status: TruckStatus;

  /**
   * @generated from field: required uint64 owner_organization_id = 6 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * To be deprecated in favor of truck_type.model
   *
   * @generated from field: optional string model = 7;
   */
  model: string;

  /**
   * To be deprecated in favor of truck_type.weight_kg
   *
   * @generated from field: optional double truck_weight = 8 [json_name = "truck_weight"];
   */
  truckWeight: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_weight_ts = 9 [json_name = "last_weight_ts"];
   */
  lastWeightTs?: Timestamp;

  /**
   * To be deprecated in favor of truck_type.volume
   *
   * @generated from field: optional uint64 capacity = 10;
   */
  capacity: bigint;

  /**
   * @generated from field: optional uint32 year = 11;
   */
  year: number;

  /**
   * @generated from field: optional string color = 12;
   */
  color: string;

  /**
   * @generated from field: optional raccoonai.CustomTruckType truck_type = 13 [json_name = "truck_type"];
   */
  truckType?: CustomTruckType;

  /**
   * @generated from field: optional string tech_passport = 14 [json_name = "tech_passport"];
   */
  techPassport: string;

  /**
   * @generated from field: optional raccoonai.Organization owner_organization = 15 [json_name = "owner_organization"];
   */
  ownerOrganization?: Organization;

  /**
   * @generated from field: optional raccoonai.EmissionRecord last_emission_record = 16 [json_name = "last_emission_record"];
   */
  lastEmissionRecord?: EmissionRecord;

  /**
   * Latest GPS point of the truck. Filled only by RPCs that say so
   * (DriverService.MyPlannedShifts); absent when the truck has no GPS data.
   *
   * @generated from field: optional raccoonai.TruckPositionList.TruckPosition latest_position = 17 [json_name = "latest_position"];
   */
  latestPosition?: TruckPositionList_TruckPosition;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message raccoonai.Truck
 */
export type TruckJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * To be deprecated in favor of truck_type.type
   *
   * @generated from field: optional raccoonai.TruckType type = 3;
   */
  type?: TruckTypeJson;

  /**
   * @generated from field: required string plate_number = 4 [json_name = "plate_number"];
   */
  plate_number?: string;

  /**
   * @generated from field: required raccoonai.TruckStatus status = 5;
   */
  status?: TruckStatusJson;

  /**
   * @generated from field: required uint64 owner_organization_id = 6 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * To be deprecated in favor of truck_type.model
   *
   * @generated from field: optional string model = 7;
   */
  model?: string;

  /**
   * To be deprecated in favor of truck_type.weight_kg
   *
   * @generated from field: optional double truck_weight = 8 [json_name = "truck_weight"];
   */
  truck_weight?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional google.protobuf.Timestamp last_weight_ts = 9 [json_name = "last_weight_ts"];
   */
  last_weight_ts?: TimestampJson;

  /**
   * To be deprecated in favor of truck_type.volume
   *
   * @generated from field: optional uint64 capacity = 10;
   */
  capacity?: string;

  /**
   * @generated from field: optional uint32 year = 11;
   */
  year?: number;

  /**
   * @generated from field: optional string color = 12;
   */
  color?: string;

  /**
   * @generated from field: optional raccoonai.CustomTruckType truck_type = 13 [json_name = "truck_type"];
   */
  truck_type?: CustomTruckTypeJson;

  /**
   * @generated from field: optional string tech_passport = 14 [json_name = "tech_passport"];
   */
  tech_passport?: string;

  /**
   * @generated from field: optional raccoonai.Organization owner_organization = 15 [json_name = "owner_organization"];
   */
  owner_organization?: OrganizationJson;

  /**
   * @generated from field: optional raccoonai.EmissionRecord last_emission_record = 16 [json_name = "last_emission_record"];
   */
  last_emission_record?: EmissionRecordJson;

  /**
   * Latest GPS point of the truck. Filled only by RPCs that say so
   * (DriverService.MyPlannedShifts); absent when the truck has no GPS data.
   *
   * @generated from field: optional raccoonai.TruckPositionList.TruckPosition latest_position = 17 [json_name = "latest_position"];
   */
  latest_position?: TruckPositionList_TruckPositionJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.Truck.
 * Use `create(TruckSchema)` to create a new message.
 */
export const TruckSchema: GenMessage<Truck, {jsonType: TruckJson}> = /*@__PURE__*/
  messageDesc(file_truck, 1);

/**
 * @generated from message raccoonai.TruckCreate
 */
export type TruckCreate = Message<"raccoonai.TruckCreate"> & {
  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required string plate_number = 2 [json_name = "plate_number"];
   */
  plateNumber: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional raccoonai.TruckType type = 3;
   */
  type: TruckType;

  /**
   * To be deprecated
   *
   * @generated from field: optional string model = 4;
   */
  model: string;

  /**
   * @generated from field: optional double truck_weight = 5 [json_name = "truck_weight"];
   */
  truckWeight: number;

  /**
   * To be deprecated
   *
   * @generated from field: optional uint64 capacity = 6;
   */
  capacity: bigint;

  /**
   * @generated from field: optional uint32 year = 7;
   */
  year: number;

  /**
   * @generated from field: optional string color = 8;
   */
  color: string;

  /**
   * To be required
   *
   * @generated from field: optional uint64 truck_type_id = 9 [json_name = "truck_type_id"];
   */
  truckTypeId: bigint;

  /**
   * @generated from field: optional string tech_passport = 10 [json_name = "tech_passport"];
   */
  techPassport: string;
};

/**
 * @generated from message raccoonai.TruckCreate
 */
export type TruckCreateJson = {
  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required string plate_number = 2 [json_name = "plate_number"];
   */
  plate_number?: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional raccoonai.TruckType type = 3;
   */
  type?: TruckTypeJson;

  /**
   * To be deprecated
   *
   * @generated from field: optional string model = 4;
   */
  model?: string;

  /**
   * @generated from field: optional double truck_weight = 5 [json_name = "truck_weight"];
   */
  truck_weight?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * To be deprecated
   *
   * @generated from field: optional uint64 capacity = 6;
   */
  capacity?: string;

  /**
   * @generated from field: optional uint32 year = 7;
   */
  year?: number;

  /**
   * @generated from field: optional string color = 8;
   */
  color?: string;

  /**
   * To be required
   *
   * @generated from field: optional uint64 truck_type_id = 9 [json_name = "truck_type_id"];
   */
  truck_type_id?: string;

  /**
   * @generated from field: optional string tech_passport = 10 [json_name = "tech_passport"];
   */
  tech_passport?: string;
};

/**
 * Describes the message raccoonai.TruckCreate.
 * Use `create(TruckCreateSchema)` to create a new message.
 */
export const TruckCreateSchema: GenMessage<TruckCreate, {jsonType: TruckCreateJson}> = /*@__PURE__*/
  messageDesc(file_truck, 2);

/**
 * @generated from message raccoonai.TruckUpdate
 */
export type TruckUpdate = Message<"raccoonai.TruckUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * To be deprecated
   *
   * @generated from field: optional raccoonai.TruckType type = 3;
   */
  type: TruckType;

  /**
   * @generated from field: optional string plate_number = 4 [json_name = "plate_number"];
   */
  plateNumber: string;

  /**
   * @generated from field: optional raccoonai.TruckStatus status = 5;
   */
  status: TruckStatus;

  /**
   * To be deprecated
   *
   * @generated from field: optional string model = 6;
   */
  model: string;

  /**
   * @generated from field: optional double truck_weight = 7 [json_name = "truck_weight"];
   */
  truckWeight: number;

  /**
   * To be deprecated
   *
   * @generated from field: optional uint64 capacity = 8;
   */
  capacity: bigint;

  /**
   * @generated from field: optional uint32 year = 9;
   */
  year: number;

  /**
   * To be deprecated
   *
   * @generated from field: optional string color = 10;
   */
  color: string;

  /**
   * @generated from field: optional uint64 truck_type_id = 11 [json_name = "truck_type_id"];
   */
  truckTypeId: bigint;

  /**
   * @generated from field: optional string tech_passport = 12 [json_name = "tech_passport"];
   */
  techPassport: string;
};

/**
 * @generated from message raccoonai.TruckUpdate
 */
export type TruckUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * To be deprecated
   *
   * @generated from field: optional raccoonai.TruckType type = 3;
   */
  type?: TruckTypeJson;

  /**
   * @generated from field: optional string plate_number = 4 [json_name = "plate_number"];
   */
  plate_number?: string;

  /**
   * @generated from field: optional raccoonai.TruckStatus status = 5;
   */
  status?: TruckStatusJson;

  /**
   * To be deprecated
   *
   * @generated from field: optional string model = 6;
   */
  model?: string;

  /**
   * @generated from field: optional double truck_weight = 7 [json_name = "truck_weight"];
   */
  truck_weight?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * To be deprecated
   *
   * @generated from field: optional uint64 capacity = 8;
   */
  capacity?: string;

  /**
   * @generated from field: optional uint32 year = 9;
   */
  year?: number;

  /**
   * To be deprecated
   *
   * @generated from field: optional string color = 10;
   */
  color?: string;

  /**
   * @generated from field: optional uint64 truck_type_id = 11 [json_name = "truck_type_id"];
   */
  truck_type_id?: string;

  /**
   * @generated from field: optional string tech_passport = 12 [json_name = "tech_passport"];
   */
  tech_passport?: string;
};

/**
 * Describes the message raccoonai.TruckUpdate.
 * Use `create(TruckUpdateSchema)` to create a new message.
 */
export const TruckUpdateSchema: GenMessage<TruckUpdate, {jsonType: TruckUpdateJson}> = /*@__PURE__*/
  messageDesc(file_truck, 3);

/**
 * @generated from message raccoonai.TruckStatusUpdate
 */
export type TruckStatusUpdate = Message<"raccoonai.TruckStatusUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required raccoonai.TruckStatus status = 2;
   */
  status: TruckStatus;
};

/**
 * @generated from message raccoonai.TruckStatusUpdate
 */
export type TruckStatusUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required raccoonai.TruckStatus status = 2;
   */
  status?: TruckStatusJson;
};

/**
 * Describes the message raccoonai.TruckStatusUpdate.
 * Use `create(TruckStatusUpdateSchema)` to create a new message.
 */
export const TruckStatusUpdateSchema: GenMessage<TruckStatusUpdate, {jsonType: TruckStatusUpdateJson}> = /*@__PURE__*/
  messageDesc(file_truck, 4);

/**
 * To be deprecated
 *
 * @generated from message raccoonai.TruckInProximity
 */
export type TruckInProximity = Message<"raccoonai.TruckInProximity"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 provider_org_id = 2 [json_name = "provider_org_id"];
   */
  providerOrgId: bigint;

  /**
   * @generated from field: required uint64 location_id = 3 [json_name = "location_id"];
   */
  locationId: bigint;

  /**
   * "pickup_location" or "location"
   *
   * @generated from field: required string location_type = 4 [json_name = "location_type"];
   */
  locationType: string;

  /**
   * @generated from field: required int64 start_ts = 5 [json_name = "start_ts"];
   */
  startTs: bigint;

  /**
   * @generated from field: required int64 end_ts = 6 [json_name = "end_ts"];
   */
  endTs: bigint;
};

/**
 * To be deprecated
 *
 * @generated from message raccoonai.TruckInProximity
 */
export type TruckInProximityJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 provider_org_id = 2 [json_name = "provider_org_id"];
   */
  provider_org_id?: string;

  /**
   * @generated from field: required uint64 location_id = 3 [json_name = "location_id"];
   */
  location_id?: string;

  /**
   * "pickup_location" or "location"
   *
   * @generated from field: required string location_type = 4 [json_name = "location_type"];
   */
  location_type?: string;

  /**
   * @generated from field: required int64 start_ts = 5 [json_name = "start_ts"];
   */
  start_ts?: string;

  /**
   * @generated from field: required int64 end_ts = 6 [json_name = "end_ts"];
   */
  end_ts?: string;
};

/**
 * Describes the message raccoonai.TruckInProximity.
 * Use `create(TruckInProximitySchema)` to create a new message.
 */
export const TruckInProximitySchema: GenMessage<TruckInProximity, {jsonType: TruckInProximityJson}> = /*@__PURE__*/
  messageDesc(file_truck, 5);

/**
 * @generated from message raccoonai.TruckCapability
 */
export type TruckCapability = Message<"raccoonai.TruckCapability"> & {
  /**
   * @generated from field: required raccoonai.ContainerType container_type = 1 [json_name = "container_type"];
   */
  containerType?: ContainerType;

  /**
   * @generated from field: required raccoonai.JobType job_type = 2 [json_name = "job_type"];
   */
  jobType: JobType;
};

/**
 * @generated from message raccoonai.TruckCapability
 */
export type TruckCapabilityJson = {
  /**
   * @generated from field: required raccoonai.ContainerType container_type = 1 [json_name = "container_type"];
   */
  container_type?: ContainerTypeJson;

  /**
   * @generated from field: required raccoonai.JobType job_type = 2 [json_name = "job_type"];
   */
  job_type?: JobTypeJson;
};

/**
 * Describes the message raccoonai.TruckCapability.
 * Use `create(TruckCapabilitySchema)` to create a new message.
 */
export const TruckCapabilitySchema: GenMessage<TruckCapability, {jsonType: TruckCapabilityJson}> = /*@__PURE__*/
  messageDesc(file_truck, 6);

/**
 * @generated from message raccoonai.TruckCapabilityUpsert
 */
export type TruckCapabilityUpsert = Message<"raccoonai.TruckCapabilityUpsert"> & {
  /**
   * @generated from field: required uint64 container_type_id = 1 [json_name = "container_type_id"];
   */
  containerTypeId: bigint;

  /**
   * @generated from field: required raccoonai.JobType job_type = 2 [json_name = "job_type"];
   */
  jobType: JobType;
};

/**
 * @generated from message raccoonai.TruckCapabilityUpsert
 */
export type TruckCapabilityUpsertJson = {
  /**
   * @generated from field: required uint64 container_type_id = 1 [json_name = "container_type_id"];
   */
  container_type_id?: string;

  /**
   * @generated from field: required raccoonai.JobType job_type = 2 [json_name = "job_type"];
   */
  job_type?: JobTypeJson;
};

/**
 * Describes the message raccoonai.TruckCapabilityUpsert.
 * Use `create(TruckCapabilityUpsertSchema)` to create a new message.
 */
export const TruckCapabilityUpsertSchema: GenMessage<TruckCapabilityUpsert, {jsonType: TruckCapabilityUpsertJson}> = /*@__PURE__*/
  messageDesc(file_truck, 7);

/**
 * @generated from message raccoonai.CustomTruckType
 */
export type CustomTruckType = Message<"raccoonai.CustomTruckType"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required string name = 3;
   */
  name: string;

  /**
   * @generated from field: required string manufacturer = 4;
   */
  manufacturer: string;

  /**
   * @generated from field: required string model = 5;
   */
  model: string;

  /**
   * @generated from field: required float volume = 6;
   */
  volume: number;

  /**
   * might not be needed
   *
   * @generated from field: optional double weight_kg = 7 [json_name = "weight_kg"];
   */
  weightKg: number;

  /**
   * @generated from field: optional float compaction_factor = 8 [json_name = "compaction_factor"];
   */
  compactionFactor: number;

  /**
   * @generated from field: optional raccoonai.TruckType type = 9;
   */
  type: TruckType;

  /**
   * @generated from field: repeated raccoonai.TruckCapability truck_type_capabilities = 10 [json_name = "truck_type_capabilities"];
   */
  truckTypeCapabilities: TruckCapability[];

  /**
   * @generated from field: optional raccoonai.TruckLoadType load_type = 11 [json_name = "load_type"];
   */
  loadType: TruckLoadType;

  /**
   * @generated from field: optional raccoonai.TruckStandard euro_type = 12 [json_name = "euro_type"];
   */
  euroType: TruckStandard;

  /**
   * @generated from field: optional uint32 truck_count = 13 [json_name = "truck_count"];
   */
  truckCount: number;

  /**
   * @generated from field: optional raccoonai.TruckEngineType engine_type = 14 [json_name = "engine_type"];
   */
  engineType: TruckEngineType;

  /**
   * The company that made the type. Set only where the caller preloads it (ListTruckTypes, whose list spans the
   * holding).
   *
   * @generated from field: optional raccoonai.Organization owner_organization = 15 [json_name = "owner_organization"];
   */
  ownerOrganization?: Organization;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message raccoonai.CustomTruckType
 */
export type CustomTruckTypeJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required string name = 3;
   */
  name?: string;

  /**
   * @generated from field: required string manufacturer = 4;
   */
  manufacturer?: string;

  /**
   * @generated from field: required string model = 5;
   */
  model?: string;

  /**
   * @generated from field: required float volume = 6;
   */
  volume?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * might not be needed
   *
   * @generated from field: optional double weight_kg = 7 [json_name = "weight_kg"];
   */
  weight_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float compaction_factor = 8 [json_name = "compaction_factor"];
   */
  compaction_factor?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional raccoonai.TruckType type = 9;
   */
  type?: TruckTypeJson;

  /**
   * @generated from field: repeated raccoonai.TruckCapability truck_type_capabilities = 10 [json_name = "truck_type_capabilities"];
   */
  truck_type_capabilities?: TruckCapabilityJson[];

  /**
   * @generated from field: optional raccoonai.TruckLoadType load_type = 11 [json_name = "load_type"];
   */
  load_type?: TruckLoadTypeJson;

  /**
   * @generated from field: optional raccoonai.TruckStandard euro_type = 12 [json_name = "euro_type"];
   */
  euro_type?: TruckStandardJson;

  /**
   * @generated from field: optional uint32 truck_count = 13 [json_name = "truck_count"];
   */
  truck_count?: number;

  /**
   * @generated from field: optional raccoonai.TruckEngineType engine_type = 14 [json_name = "engine_type"];
   */
  engine_type?: TruckEngineTypeJson;

  /**
   * The company that made the type. Set only where the caller preloads it (ListTruckTypes, whose list spans the
   * holding).
   *
   * @generated from field: optional raccoonai.Organization owner_organization = 15 [json_name = "owner_organization"];
   */
  owner_organization?: OrganizationJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.CustomTruckType.
 * Use `create(CustomTruckTypeSchema)` to create a new message.
 */
export const CustomTruckTypeSchema: GenMessage<CustomTruckType, {jsonType: CustomTruckTypeJson}> = /*@__PURE__*/
  messageDesc(file_truck, 8);

/**
 * @generated from message raccoonai.CustomTruckTypeCreate
 */
export type CustomTruckTypeCreate = Message<"raccoonai.CustomTruckTypeCreate"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required string name = 2;
   */
  name: string;

  /**
   * @generated from field: required string manufacturer = 3;
   */
  manufacturer: string;

  /**
   * @generated from field: required string model = 4;
   */
  model: string;

  /**
   * @generated from field: required float volume = 5;
   */
  volume: number;

  /**
   * @generated from field: optional double weight_kg = 6 [json_name = "weight_kg"];
   */
  weightKg: number;

  /**
   * @generated from field: optional float compaction_factor = 7 [json_name = "compaction_factor"];
   */
  compactionFactor: number;

  /**
   * @generated from field: optional raccoonai.TruckType type = 8;
   */
  type: TruckType;

  /**
   * @generated from field: repeated raccoonai.TruckCapabilityUpsert truck_type_capabilities = 9 [json_name = "truck_type_capabilities_upsert"];
   */
  truckTypeCapabilities: TruckCapabilityUpsert[];

  /**
   * @generated from field: optional raccoonai.TruckLoadType load_type = 10 [json_name = "load_type"];
   */
  loadType: TruckLoadType;

  /**
   * @generated from field: optional raccoonai.TruckStandard euro_type = 11 [json_name = "euro_type"];
   */
  euroType: TruckStandard;
};

/**
 * @generated from message raccoonai.CustomTruckTypeCreate
 */
export type CustomTruckTypeCreateJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required string name = 2;
   */
  name?: string;

  /**
   * @generated from field: required string manufacturer = 3;
   */
  manufacturer?: string;

  /**
   * @generated from field: required string model = 4;
   */
  model?: string;

  /**
   * @generated from field: required float volume = 5;
   */
  volume?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double weight_kg = 6 [json_name = "weight_kg"];
   */
  weight_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float compaction_factor = 7 [json_name = "compaction_factor"];
   */
  compaction_factor?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional raccoonai.TruckType type = 8;
   */
  type?: TruckTypeJson;

  /**
   * @generated from field: repeated raccoonai.TruckCapabilityUpsert truck_type_capabilities = 9 [json_name = "truck_type_capabilities_upsert"];
   */
  truck_type_capabilities_upsert?: TruckCapabilityUpsertJson[];

  /**
   * @generated from field: optional raccoonai.TruckLoadType load_type = 10 [json_name = "load_type"];
   */
  load_type?: TruckLoadTypeJson;

  /**
   * @generated from field: optional raccoonai.TruckStandard euro_type = 11 [json_name = "euro_type"];
   */
  euro_type?: TruckStandardJson;
};

/**
 * Describes the message raccoonai.CustomTruckTypeCreate.
 * Use `create(CustomTruckTypeCreateSchema)` to create a new message.
 */
export const CustomTruckTypeCreateSchema: GenMessage<CustomTruckTypeCreate, {jsonType: CustomTruckTypeCreateJson}> = /*@__PURE__*/
  messageDesc(file_truck, 9);

/**
 * @generated from message raccoonai.CustomTruckTypeUpdate
 */
export type CustomTruckTypeUpdate = Message<"raccoonai.CustomTruckTypeUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required string name = 3;
   */
  name: string;

  /**
   * @generated from field: optional string manufacturer = 4;
   */
  manufacturer: string;

  /**
   * @generated from field: optional string model = 5;
   */
  model: string;

  /**
   * @generated from field: optional float volume = 6;
   */
  volume: number;

  /**
   * @generated from field: optional double weight_kg = 7 [json_name = "weight_kg"];
   */
  weightKg: number;

  /**
   * @generated from field: optional float compaction_factor = 8 [json_name = "compaction_factor"];
   */
  compactionFactor: number;

  /**
   * @generated from field: optional raccoonai.TruckType type = 9;
   */
  type: TruckType;

  /**
   * @generated from field: repeated raccoonai.TruckCapabilityUpsert truck_type_capabilities = 10 [json_name = "truck_type_capabilities_upsert"];
   */
  truckTypeCapabilities: TruckCapabilityUpsert[];

  /**
   * If true, existing capabilities not included in the request will be deleted.
   * If false, existing capabilities will be retained and only upserted/updated.
   *
   * @generated from field: optional bool to_update_matrix = 11 [default = true, json_name = "update_matrix"];
   */
  toUpdateMatrix: boolean;

  /**
   * @generated from field: optional raccoonai.TruckLoadType load_type = 12 [json_name = "load_type"];
   */
  loadType: TruckLoadType;

  /**
   * @generated from field: optional raccoonai.TruckStandard euro_type = 13 [json_name = "euro_type"];
   */
  euroType: TruckStandard;
};

/**
 * @generated from message raccoonai.CustomTruckTypeUpdate
 */
export type CustomTruckTypeUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required string name = 3;
   */
  name?: string;

  /**
   * @generated from field: optional string manufacturer = 4;
   */
  manufacturer?: string;

  /**
   * @generated from field: optional string model = 5;
   */
  model?: string;

  /**
   * @generated from field: optional float volume = 6;
   */
  volume?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double weight_kg = 7 [json_name = "weight_kg"];
   */
  weight_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float compaction_factor = 8 [json_name = "compaction_factor"];
   */
  compaction_factor?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional raccoonai.TruckType type = 9;
   */
  type?: TruckTypeJson;

  /**
   * @generated from field: repeated raccoonai.TruckCapabilityUpsert truck_type_capabilities = 10 [json_name = "truck_type_capabilities_upsert"];
   */
  truck_type_capabilities_upsert?: TruckCapabilityUpsertJson[];

  /**
   * If true, existing capabilities not included in the request will be deleted.
   * If false, existing capabilities will be retained and only upserted/updated.
   *
   * @generated from field: optional bool to_update_matrix = 11 [default = true, json_name = "update_matrix"];
   */
  update_matrix?: boolean;

  /**
   * @generated from field: optional raccoonai.TruckLoadType load_type = 12 [json_name = "load_type"];
   */
  load_type?: TruckLoadTypeJson;

  /**
   * @generated from field: optional raccoonai.TruckStandard euro_type = 13 [json_name = "euro_type"];
   */
  euro_type?: TruckStandardJson;
};

/**
 * Describes the message raccoonai.CustomTruckTypeUpdate.
 * Use `create(CustomTruckTypeUpdateSchema)` to create a new message.
 */
export const CustomTruckTypeUpdateSchema: GenMessage<CustomTruckTypeUpdate, {jsonType: CustomTruckTypeUpdateJson}> = /*@__PURE__*/
  messageDesc(file_truck, 10);

/**
 * @generated from message raccoonai.CustomTruckTypeList
 */
export type CustomTruckTypeList = Message<"raccoonai.CustomTruckTypeList"> & {
  /**
   * @generated from field: repeated raccoonai.CustomTruckType custom_truck_types = 1 [json_name = "custom_truck_types"];
   */
  customTruckTypes: CustomTruckType[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.CustomTruckTypeList
 */
export type CustomTruckTypeListJson = {
  /**
   * @generated from field: repeated raccoonai.CustomTruckType custom_truck_types = 1 [json_name = "custom_truck_types"];
   */
  custom_truck_types?: CustomTruckTypeJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.CustomTruckTypeList.
 * Use `create(CustomTruckTypeListSchema)` to create a new message.
 */
export const CustomTruckTypeListSchema: GenMessage<CustomTruckTypeList, {jsonType: CustomTruckTypeListJson}> = /*@__PURE__*/
  messageDesc(file_truck, 11);

/**
 * Same as TruckEmissionRecord, but is part of a truck information.
 * To avoid circular dependency between truck.proto and emission_service.proto.
 *
 * @generated from message raccoonai.EmissionRecord
 */
export type EmissionRecord = Message<"raccoonai.EmissionRecord"> & {
  /**
   * Exhaust metrics for petrol engine type
   *
   * Carbon monoxide (CO) in %
   *
   * @generated from field: optional float co_percent = 1 [json_name = "co_percent"];
   */
  coPercent: number;

  /**
   * Carbon dioxide (CO2) in %
   *
   * @generated from field: optional float co2_percent = 2 [json_name = "co2_percent"];
   */
  co2Percent: number;

  /**
   * Oxygen (O2) in %
   *
   * @generated from field: optional float o2_percent = 3 [json_name = "o2_percent"];
   */
  o2Percent: number;

  /**
   * Hydrocarbons (CH) in ppm (10^-6)
   *
   * @generated from field: optional int32 ch_ppm = 4 [json_name = "ch_ppm"];
   */
  chPpm: number;

  /**
   * Exhaust metrics for diesel engine type
   *
   * Light Absorption Coefficient (K) in %
   *
   * @generated from field: optional float k_percent = 5 [json_name = "k_percent"];
   */
  kPercent: number;

  /**
   * Light Attenuation Coefficient (N) in %
   *
   * @generated from field: optional float n_percent = 6 [json_name = "n_percent"];
   */
  nPercent: number;
};

/**
 * Same as TruckEmissionRecord, but is part of a truck information.
 * To avoid circular dependency between truck.proto and emission_service.proto.
 *
 * @generated from message raccoonai.EmissionRecord
 */
export type EmissionRecordJson = {
  /**
   * Exhaust metrics for petrol engine type
   *
   * Carbon monoxide (CO) in %
   *
   * @generated from field: optional float co_percent = 1 [json_name = "co_percent"];
   */
  co_percent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Carbon dioxide (CO2) in %
   *
   * @generated from field: optional float co2_percent = 2 [json_name = "co2_percent"];
   */
  co2_percent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Oxygen (O2) in %
   *
   * @generated from field: optional float o2_percent = 3 [json_name = "o2_percent"];
   */
  o2_percent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Hydrocarbons (CH) in ppm (10^-6)
   *
   * @generated from field: optional int32 ch_ppm = 4 [json_name = "ch_ppm"];
   */
  ch_ppm?: number;

  /**
   * Exhaust metrics for diesel engine type
   *
   * Light Absorption Coefficient (K) in %
   *
   * @generated from field: optional float k_percent = 5 [json_name = "k_percent"];
   */
  k_percent?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Light Attenuation Coefficient (N) in %
   *
   * @generated from field: optional float n_percent = 6 [json_name = "n_percent"];
   */
  n_percent?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message raccoonai.EmissionRecord.
 * Use `create(EmissionRecordSchema)` to create a new message.
 */
export const EmissionRecordSchema: GenMessage<EmissionRecord, {jsonType: EmissionRecordJson}> = /*@__PURE__*/
  messageDesc(file_truck, 12);

/**
 * @generated from message raccoonai.SearchTruckRequest
 */
export type SearchTruckRequest = Message<"raccoonai.SearchTruckRequest"> & {
  /**
   * @generated from field: required string plate_number = 1 [json_name = "plate_number"];
   */
  plateNumber: string;
};

/**
 * @generated from message raccoonai.SearchTruckRequest
 */
export type SearchTruckRequestJson = {
  /**
   * @generated from field: required string plate_number = 1 [json_name = "plate_number"];
   */
  plate_number?: string;
};

/**
 * Describes the message raccoonai.SearchTruckRequest.
 * Use `create(SearchTruckRequestSchema)` to create a new message.
 */
export const SearchTruckRequestSchema: GenMessage<SearchTruckRequest, {jsonType: SearchTruckRequestJson}> = /*@__PURE__*/
  messageDesc(file_truck, 13);

/**
 * @generated from message raccoonai.SearchTruckResult
 */
export type SearchTruckResult = Message<"raccoonai.SearchTruckResult"> & {
  /**
   * @generated from field: optional bool is_guest = 1 [json_name = "is_guest"];
   */
  isGuest: boolean;

  /**
   * @generated from field: optional raccoonai.Truck truck = 2;
   */
  truck?: Truck;

  /**
   * @generated from field: optional raccoonai.Organization org = 3;
   */
  org?: Organization;
};

/**
 * @generated from message raccoonai.SearchTruckResult
 */
export type SearchTruckResultJson = {
  /**
   * @generated from field: optional bool is_guest = 1 [json_name = "is_guest"];
   */
  is_guest?: boolean;

  /**
   * @generated from field: optional raccoonai.Truck truck = 2;
   */
  truck?: TruckJson;

  /**
   * @generated from field: optional raccoonai.Organization org = 3;
   */
  org?: OrganizationJson;
};

/**
 * Describes the message raccoonai.SearchTruckResult.
 * Use `create(SearchTruckResultSchema)` to create a new message.
 */
export const SearchTruckResultSchema: GenMessage<SearchTruckResult, {jsonType: SearchTruckResultJson}> = /*@__PURE__*/
  messageDesc(file_truck, 14);

/**
 * @generated from message raccoonai.SearchTruckResponse
 */
export type SearchTruckResponse = Message<"raccoonai.SearchTruckResponse"> & {
  /**
   * @generated from field: repeated raccoonai.SearchTruckResult results = 1;
   */
  results: SearchTruckResult[];
};

/**
 * @generated from message raccoonai.SearchTruckResponse
 */
export type SearchTruckResponseJson = {
  /**
   * @generated from field: repeated raccoonai.SearchTruckResult results = 1;
   */
  results?: SearchTruckResultJson[];
};

/**
 * Describes the message raccoonai.SearchTruckResponse.
 * Use `create(SearchTruckResponseSchema)` to create a new message.
 */
export const SearchTruckResponseSchema: GenMessage<SearchTruckResponse, {jsonType: SearchTruckResponseJson}> = /*@__PURE__*/
  messageDesc(file_truck, 15);

